import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/source/admin/logUploadControl/';

function baseApi() {

    function insert(data) {
        return Post(baseUrl + 'insertLogUploadControl', data);
    }

    function deleteData(data) {
        return Post(baseUrl + 'deleteLogUploadControl', data);
    }

    function update(data) {
        return Post(baseUrl + 'updateLogUploadControl', data);
    }

    function query(data) {
        return Post(baseUrl + 'queryLogUploadControl', data);
    }

    return {
        insert, deleteData, update, query
    };
}

export const archiveControlApi = baseApi();
